import getLang from './get-lang';
import getRegion from './get-region';
import getToken from './get-token';
import setToken from './set-token';
import getMaxifyHeaders from './get-maxify-headers';

export { getLang, getRegion, getToken, setToken, getMaxifyHeaders };
